export const sandboxCompletedHtml = `
<h1 id="welkom-bij-postcode-api">Welkom bij Postcode API</h1>
<p>Er is zojuist een e-mail verstuurd met daarin je gratis API key. Bewaar de API key goed, want deze heb je nodig in je applicatie en om in te kunnen loggen op je <a href="/account">account</a>. In de mail omschrijven we stap voor stap wat je moet doen om de API werkend te krijgen in je applicatie. Op naar je eerste API call!</p>
`
